import React from 'react';
import {
  Button,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from '@mui/material';
import { Page } from '@/declarations/models/Page';
import { MaterialSymbol } from '@/components/MaterialSymbol';
import Styles from '@/assets/js/Styles';
import { useTranslation } from 'react-i18next';

type Props = {
  pages: Page[];
  pagesCount: number;
  tComp: (key: string) => string;
  getSanitizedUrl: (url: string) => string | null;
};

export function AnalysisTable({ pages, pagesCount, tComp, getSanitizedUrl }: Props) {
  const { t: tCommon } = useTranslation('common');
  return (
    <>
      <Typography>Totalt {pagesCount} sider</Typography>
      <TableContainer component={Paper}>
        <Table className='compact-table' stickyHeader sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell align='left'>{tComp('AnalyticsView.AnalysisTable.PageTitle')}</TableCell>
              <TableCell align='left'>{tComp('AnalyticsView.AnalysisTable.PageLocale')}</TableCell>
              <TableCell>{tComp('AnalyticsView.AnalysisTable.PageStatus')}</TableCell>
              <TableCell>{tComp('AnalyticsView.AnalysisTable.PortalUrl')}</TableCell>
              <TableCell>{tComp('AnalyticsView.AnalysisTable.EditorUrl')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pages.length > 0 ? (
              pages.map((page, idx) => (
                // eslint-disable-next-line react/no-array-index-key -- id is unique and safe here
                <TableRow key={`${idx}-${page.id}`}>
                  <TableCell>{idx + 1}</TableCell>
                  <TableCell align='left'>{page.title}</TableCell>
                  <TableCell align='left'>{page.locale}</TableCell>
                  <TableCell>{tCommon(`Status.${page.status}`)}</TableCell>
                  <TableCell>
                    {page.url && page.status !== 'draft'
                      ? (() => {
                          const sanitized = getSanitizedUrl(page.url);
                          return sanitized ? (
                            <a
                              style={{ maxWidth: '200px', lineBreak: 'anywhere' }}
                              href={sanitized}
                              target='portal'
                              rel='noopener noreferrer'>
                              {sanitized}
                            </a>
                          ) : (
                            'N/A'
                          );
                        })()
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    <a
                      href={`/editor/${page.id}`}
                      target='admin-editor'
                      rel='noopener noreferrer'
                      style={{
                        textDecoration: 'none',
                        display: 'inline-block',
                        width: '100%',
                      }}>
                      <Button
                        variant='contained'
                        sx={{
                          boxShadow: undefined,
                          px: 3,
                          whiteSpace: 'nowrap',
                          border: `1px solid ${Styles.Colors.MEDIUM_LIGHT_GREY}`,
                          minWidth: 'fit-content',
                          color: Styles.Colors.DARK_GREY,
                        }}
                        startIcon={<MaterialSymbol name='edit' fill />}>
                        {tComp(`PageTreeContent.edit`)}
                      </Button>
                    </a>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={9} align='center'>
                  No pages found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
